import * as Sentry from '@sentry/react'

import env from '../config/env'

const GOOGLE_MAPS_SCRIPT_URL = /\/maps-api-v3\//

Sentry.init({ dsn: env.SENTRY_DSN, environment: env.ENV_NAME, denyUrls: [GOOGLE_MAPS_SCRIPT_URL] })
